const layers = {
  mid: document.querySelector(".mid"),
  front: document.querySelector(".front"),
  light: document.querySelector(".light")
};

const header = document.querySelector(".header");

let currentScroll = 0;
let targetScroll = 0;

let mouseX = 0;
let mouseY = 0;

let currentX = 0;
let currentY = 0;

const ease = 0.08;

/* SCROLL */

window.addEventListener("scroll", () => {

  targetScroll = window.scrollY;

  if (window.scrollY > 40) {

    header.style.background =
      "rgba(0,0,0,0.92)";

  } else {

    header.style.background =
      "transparent";

  }

});

/* MOUSE */

window.addEventListener("mousemove", (e) => {

  mouseX =
    (e.clientX / window.innerWidth - 0.5) * 2;

  mouseY =
    (e.clientY / window.innerHeight - 0.5) * 2;

});

const isMobile = window.innerWidth < 768;

if (isMobile) {

  layers.mid.style.transform =
    `translate3d(-50%, ${currentScroll * 0.15}px, 0)`;

  layers.front.style.transform =
    `translate3d(-50%, ${currentScroll * 0.25}px, 0)`;

}
/* ANIMATION */

function animate() {

  currentScroll +=
    (targetScroll - currentScroll) * 0.065;

  currentX +=
    (mouseX - currentX) * 0.05;

  currentY +=
    (mouseY - currentY) * 0.05;

  const isMobile = window.innerWidth < 768;

  const midScroll = isMobile
    ? currentScroll * 0.12
    : currentScroll * 0.35;

  const frontScroll = isMobile
    ? currentScroll * 0.2
    : currentScroll * 0.6;

  const moveX = isMobile
    ? currentX * 10
    : currentX * 30;

  const moveY = isMobile
    ? currentY * 8
    : currentY * 20;

  layers.mid.style.transform =
    `translate3d(calc(-50% + ${moveX * 0.5}px), ${midScroll + moveY * 0.5}px, 0) scale(${1 + currentScroll * 0.00008})`;

  layers.front.style.transform =
    `translate3d(calc(-50% + ${moveX}px), ${frontScroll + moveY}px, 0) scale(${1 + currentScroll * 0.00012})`;

  layers.mid.style.filter =
    `blur(${0.4 + currentScroll * 0.0008}px)`;

  layers.front.style.filter =
    `blur(${currentScroll * 0.0005}px)`;

  layers.front.style.opacity =
    `${1 - currentScroll * 0.00022}`;

  if (!isMobile) {

    const lightX =
      (mouseX * 0.5 + 0.5) * window.innerWidth;

    const lightY =
      (mouseY * 0.5 + 0.5) * window.innerHeight;

    layers.light.style.left = `${lightX}px`;
    layers.light.style.top = `${lightY}px`;

  }

  requestAnimationFrame(animate);

}
animate();

